module.exports = "/img/qr.326e97f2.png";